import "./styles.css";
export const DashLayoutGridAtualizarPerfil = (props) => {
  return (
    <div className="container-dash-auto-perfil">
      <div className="container-login-dash-auto-perfil">
        <div className="wrap-login-dash-auto-perfil">{props.children}</div>
      </div>
    </div>
  );
};
